import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "La presente informativa descrive il trattamento dei dati personali raccolti tramite il sito e i moduli di contatto e prenotazione di Martelli Rentals.",
    sections: [
      ["Titolare del trattamento", "Martelli Rentals — Lorenzo Martelli. Contatto: martellilorenzoinstagram@gmail.com."],
      ["Dati raccolti", "Nome, cognome, e-mail, telefono, dettagli del soggiorno e messaggi inviati tramite i moduli."],
      ["Finalità", "Rispondere alle richieste, gestire le prenotazioni e fornire assistenza. I dati non vengono ceduti a terzi non autorizzati."],
      ["Conservazione", "I dati sono conservati per il tempo necessario alle finalità indicate e agli obblighi di legge."],
      ["Diritti dell’utente", "Puoi richiedere accesso, rettifica o cancellazione dei tuoi dati scrivendo al titolare."],
    ],
  },
  cookie: {
    title: "Cookie Policy",
    intro: "Il sito utilizza cookie tecnici essenziali e, previo consenso, cookie di analisi e marketing.",
    sections: [
      ["Cookie essenziali", "Necessari al funzionamento del sito. Sempre attivi."],
      ["Cookie di analisi", "Utilizzati per comprendere l’utilizzo del sito. Caricati solo dopo il consenso."],
      ["Cookie di marketing", "Utilizzati per finalità promozionali. Caricati solo dopo il consenso."],
      ["Gestione del consenso", "Puoi modificare le preferenze in qualsiasi momento tramite il banner cookie."],
    ],
  },
  termini: {
    title: "Termini e condizioni",
    intro: "Le presenti condizioni disciplinano l’utilizzo del sito e il rapporto con Martelli Rentals. Chi siamo: una collezione di strutture ricettive gestite personalmente da Lorenzo Martelli tra Abruzzo e Roma.",
    sections: [
      ["Prenotazioni", "Le richieste inviate tramite il sito costituiscono una domanda di prenotazione, confermata separatamente da Martelli Rentals."],
      ["Tariffe e disponibilità", "Prezzi e disponibilità mostrati in questa versione sono dimostrativi e verranno collegati al sistema di prenotazione reale."],
      ["Condizioni di soggiorno", "Orari di check-in/out, regole della casa e politiche di cancellazione possono variare per struttura."],
      ["Responsabilità", "Struttura tecnica da sottoporre a verifica legale prima della pubblicazione definitiva."],
    ],
  },
};

export default function LegalPage({ type }) {
  const c = CONTENT[type];
  useEffect(() => { window.scrollTo(0, 0); document.title = `${c.title} · Martelli Rentals`; }, [c.title]);
  return (
    <>
      <Header />
      <main className="pt-32 pb-24 min-h-[70vh]">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-brand-brown hover:text-brand-olive mb-8"><ArrowLeft className="w-4 h-4" /> Torna alla home</Link>
          <h1 className="font-heading font-light text-4xl md:text-5xl text-brand-black">{c.title}</h1>
          <p className="mt-4 text-brand-brown leading-relaxed">{c.intro}</p>
          <div className="mt-8 space-y-6">
            {c.sections.map(([h, t], i) => (
              <div key={i}>
                <h2 className="font-heading text-2xl text-brand-black">{h}</h2>
                <p className="mt-2 text-brand-brown leading-relaxed">{t}</p>
              </div>
            ))}
          </div>
          <p className="mt-10 text-xs text-brand-brown/60 italic">Documento placeholder da sottoporre a verifica legale prima della pubblicazione.</p>
        </div>
      </main>
      <Footer />
    </>
  );
}
